module.exports = __webpack_public_path__ + "static/img/achieve_icon.b83c233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achieve_icon.png
// module id = 1zuA
// module chunks = 167